export const getFormValid = ({ errors, submitCount }) =>
  Object.keys(errors).reduce((prev, cur) => {
    const n = { ...prev };
    n[cur] = errors[cur] && submitCount > 0 ? -1 : 0;

    return n;
  }, {});

export const fixedSubmitForm = ({ submitForm, validateForm }) =>
  new Promise((resolve, reject) => {
    submitForm()
      .then(validateForm)
      .then((errors) => {
        const isValid = Object.keys(errors).length === 0;
        if (isValid) {
          resolve();
        } else {
          reject();
        }
      })
      .catch(() => {
        reject();
      });
  });

export const checkFormFieldValidate = (value, allowNegative = false) => {
  const regex = allowNegative ? /^-?[0-9]*\.?[0-9]+$/ : /^[0-9]*\.?[0-9]+$/;
  return value && value !== '' && regex.test(value) && parseFloat(value) !== 0;
};

export const blurFocusAndScroll = (ref, isMobile) => {
  if (isMobile) {
    // Deselect the active input field and hide the keyboard
    if (document.activeElement) {
      document.activeElement.blur();
    }
    if (ref.current) {
      // Scroll to the result box
      setTimeout(() => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  }
};
